<div class="d-flex align-items-center" mat-dialog-title>
    <div class="spacer title">Kies een andere uitvoerder of ander project</div>
    <div>
        <button (click)="onCancel()" mat-icon-button tabindex="-1"><i class="fas fa-times"></i></button>
    </div>
</div>

<div mat-dialog-content>
    <p>{{ message }}</p>
</div>

<div class="d-flex justify-content-between" mat-dialog-actions>
    <button (click)="onExecutorChoice()" mat-button>Andere uitvoerder</button>
    <button (click)="onProjectChoice()" mat-button>Ander project</button>
</div>
